export default [
    {
        path: 'cns-parametrizacao',
        component: () => import(/* webpackChunkName: 'integracao-cns-parametrizacao' */ '@/views/integracao/cns/parametrizacao/Index'),
        redirect: 'cns-parametrizacao/create',
        children: [
            {
                name: 'integracao-cns-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-cns-parametrizacao' */ '@/views/integracao/cns/parametrizacao/Form'),
            },
        ],
    },
]